const SvgDevOps1 = (props) => (
  <>
    <defs />
    <path
      d="M80 96c-48.02 48.02-48.02 143.93 48 192C57.32 288 0 230.69 0 160S57.32 32 128 32s128 57.31 128 128c0 47.37-25.74 88.74-64 110.87"
      strokeLinejoin="round"
      strokeWidth="3px"
      fill="none"
      stroke="#001d6c"
    />
    <circle cx={80} cy={96} r={8} fill="#0062ff" strokeWidth={0} />
    <circle cx={80} cy={96} r={24} strokeMiterlimit={10} fill="none" stroke="#001d6c" />
    <path
      d="M304 224c48.02-48.02 48.02-143.93-48-192 70.68 0 128 57.31 128 128s-57.32 128-128 128-128-57.31-128-128c0-47.37 25.74-88.74 64-110.87"
      strokeLinejoin="round"
      strokeWidth="3px"
      fill="none"
      stroke="#001d6c"
    />
    <circle cx={304} cy={224} r={8} fill="#0062ff" strokeWidth={0} />
    <circle cx={304} cy={224} r={24} strokeMiterlimit={10} fill="none" stroke="#001d6c" />
  </>
);

export default SvgDevOps1;
